<template>
    <VJoyAvatar
        size="small"
        :full-name="subcontractorIdentity?.fullName"
        :photo-url="subcontractorPhoto"
        :color="subcontractorPhoto ? 'transparent' : 'secondary'"
        class="navbar-subcontractor-avatar"
        :class="{'navbar-subcontractor-avatar--text': !subcontractorPhoto}"
    />
</template>
<script setup lang="ts">
    import {computed} from 'vue';
    import {UserIdentityTypeEnum} from '@navbar-api';
    import {storeToRefs} from 'pinia';
    import {VJoyAvatar} from '@maltjoy/core-vue';
    import {useUserStore} from '../../user';

    const {avatarSize = '18px'} = defineProps<{
        avatarSize?: string;
    }>();

    const userStore = useUserStore();
    const {userIdentities} = storeToRefs(userStore);

    const subcontractorIdentity = userIdentities.value.find((identity) => {
        return identity.type === UserIdentityTypeEnum.Subcontractor;
    });
    const subcontractorPhoto = computed(() => {
        return subcontractorIdentity?.photo
            ? `${subcontractorIdentity.photo?.baseUrl}/${subcontractorIdentity.photo?.name}?func=crop&w=30&h=30`
            : undefined;
    });
</script>
<style lang="scss">
    .navbar-subcontractor-avatar {
        --avatar-size: v-bind(avatarSize) !important;
        width: v-bind(avatarSize);
        height: v-bind(avatarSize);
        font-size: var(--joy-font-size-primary-800);
        flex: 0 0 auto;

        &--text {
            font-size: unset;
        }
    }
</style>
